import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';

export default function getSendersOrRecipients(params: {
    isInSentItemsFolder: boolean;
    uniqueRecipients: string[];
    isInDraftsFolder: boolean;
    uniqueSenders: string[];
}): string {
    const { uniqueSenders, uniqueRecipients, isInSentItemsFolder, isInDraftsFolder } = params;
    const strings = getOwaMiniStrings();
    let sendersOrRecipients;

    if (isInSentItemsFolder || isInDraftsFolder) {
        // Show recipients for conversations belonging to drafts and sentitems folders
        sendersOrRecipients = uniqueRecipients && uniqueRecipients.join('; ');
    } else {
        sendersOrRecipients = uniqueSenders && uniqueSenders.join('; ');
    }

    // If there are no senders or no recipients add a default string [Unknown]
    // For an item in a drafts folder user may not have defined any recipients
    // For items (in both sent & drafts) that do not have recipients in To: and have recipients in Cc:/Bcc: we
    // do not receive any recipients today from server.
    if (!sendersOrRecipients) {
        sendersOrRecipients = isInDraftsFolder ? '' : strings.unknownSenderOrRecipient;
    }

    return !sendersOrRecipients ? '' : sendersOrRecipients;
}
